<script lang="ts">
  import { Col, Container, Form, FormGroup, Row } from "sveltestrap";
  import BookmarkTypeahead from "./BookmarkTypeahead.svelte";
  import Card from "../../../Core/Card.svelte";
  import Typeahead from "svelte-typeahead";
  import {states,typeaheaddata} from "../../../../Data/Forms/Widgets/Widgets"
  import TypeaheadRtlSupport from "./TypeaheadRtlSupport.svelte";
  let events = [];
  let data:{abbr:string, state:string}[] = states
</script>
<BookmarkTypeahead />
<Container fluid>
    <div class="typeahead">
      <Row>
        {#each typeaheaddata as typeItem}
          <Col sm="12" md="6">
            <Card headerTitle={typeItem.title} cardHeaderprops="pb-0">
              <div slot="customheader">
                <span>{typeItem.subtitle}</span>
              </div>
              <div slot="contentbody">
                <div id={typeItem.id}>
                  <Form class="theme-form">
                    <FormGroup>
                      <Typeahead
                        label=""
                        placeholder="States of USA"
                        {data}
                        extract={(typeItem) => typeItem.state}
                        on:select={({ detail }) => events = [...events, detail]}
                        on:clear={() => events = [...events, "clear"]}
                      />
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Card>
          </Col>
        {/each}
        <TypeaheadRtlSupport />
      </Row>
    </div>
</Container>